<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="row pb-2">
          <!-- <div class="col-lg-4 col-md-4 col-sm-12 pb-2">
            <div class="d-flex">
              <div style="width:100px">Filtrar por:</div>
              <el-select v-model="search.column" placeholder="Select" @change="changeClearInput">
                <el-option v-for="(label, key) in columns" :key="key" :value="key" :label="label"></el-option>
              </el-select>
            </div>
          </div> -->
          <div class="col-lg-3 col-md-6">
            <label class="control-label">
              Fecha de emisión
            </label>
            <!-- <template
              v-if="search.column=='created_at'"
            > -->
              <el-date-picker
                v-model="search.value"
                type="date"
                style="width: 100%;"
                placeholder="Buscar"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
                <!-- @change="getRecords" -->
            <!-- </template> -->
          </div>


          <div class="col-md-6 col-lg-3">
            <label class="control-label">
              Documento
            </label>
            <el-input v-model="full_number"
              placeholder="Ingresar número de documento"
              clearable
            ></el-input>
          </div>

          <div class="col-md-6 col-lg-3">
            <label class="control-label">
              Responsable
            </label>
            <el-select v-model="user_id" placeholder="Selecciona un responsable"
              clearable
            >
              <el-option v-for="(user, index) in users"
                :key="index"
                :label="user.name"
                :value="user.id"
              ></el-option>
            </el-select>
          </div>

          <div class="col-md-6 col-lg-3">
            <label class="control-label">
              Almacén Inicio
            </label>
            <el-select v-model="origin_establishments_id" placeholder="Selecciona un almacén"
              clearable
            >
              <el-option v-for="(establishment, index) in origin_establishments"
                :key="index"
                :label="establishment.description"
                :value="establishment.id"
              ></el-option>
            </el-select>
          </div>

          <div class="col-md-6 col-lg-3">
            <label class="control-label">
              Almacén Fin
            </label>
            <el-select v-model="final_establishments_id" placeholder="Selecciona un almacén"
              clearable
            >
              <el-option v-for="(establishment, index) in final_establishments"
                :key="index"
                :label="establishment.description"
                :value="establishment.id"
              ></el-option>
            </el-select>
          </div>

          <div class="col-md-6 col-lg-3 mt-2 d-flex align-items-end">
            <el-button type="primary"
              :loading="loading"
              @click.prevent="getRecords"
            >
              <i class="fa fa-search"></i>
              Buscar
            </el-button>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <slot name="heading"></slot>
            </thead>
            <tbody>
              <slot v-for="(row, index) in records" :row="row" :index="customIndex(index)"></slot>
            </tbody>
          </table>
          <div>
            <el-pagination
              @current-change="getRecords"
              layout="total, prev, pager, next"
              :total="pagination.total"
              :current-page.sync="pagination.current_page"
              :page-size="pagination.per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment";
import queryString from "query-string";

export default {
  props: {
    resource: String
  },
  data() {
    return {
      search: {
        column: null,
        value: null
      },
      full_number: null,
      columns: [],
      records: [],
      pagination: {},
      loading: false,
      users: [],
      user_id: null,
      origin_establishments: [],
      origin_establishments_id: null,
      final_establishments: [],
      final_establishments_id: null
    };
  },
  computed: {},
  async created() {
    this.$eventHub.$on("reloadData", async () => {
      await this.getRecords();
    });

    await this.getDataTable()
  },
  async mounted() {
    let column_resource = _.split(this.resource, "/");
    // console.log(column_resource)
    await this.$http
      .get(`/${_.head(column_resource)}/columns`)
      .then(response => {
        this.columns = response.data;
        this.search.column = _.head(Object.keys(this.columns));
      });
    await this.getRecords();
  },
  methods: {
    customIndex(index) {
      return (
        this.pagination.per_page * (this.pagination.current_page - 1) +
        index +
        1
      );
    },
    async getRecords() {
      try {
        this.loading = true
        // return this.$http
        //   .get(`/${this.resource}/records?${this.getQueryParameters()}`)
        //   .then(response => {
        //     console.log(response)
        //     this.records = response.data.data;
        //     this.pagination = response.data.meta;
        //     this.pagination.per_page = parseInt(response.data.meta.per_page);
        //   })
        //   .catch(error => {
        //     console.log('error')
        //     console.log(error)
        //   });
        const response = await this.$http.get(`/${this.resource}/records?${this.getQueryParameters()}`)
        if (response.status && response.status === 200) {
          this.records = response.data.data
          this.pagination = response.data.meta
          this.pagination.per_page = parseInt(response.data.meta.per_page)
        } else {
          this.records = []
          this.pagination = {}
        }
      } catch (error) {
        if (error.response.status === 422) {
          this.$message({
              message: error.response.data.error,
              type: 'warning'
          })
        }
      } finally {
        this.loading = false
      }
    },
    getQueryParameters() {
      return queryString.stringify({
        page: this.pagination.current_page,
        limit: this.limit,
        ...this.search,
        full_number: this.full_number,
        user_id: this.user_id,
        origin_establishments_id: this.origin_establishments_id,
        final_establishments_id: this.final_establishments_id
      });
    },
    async changeClearInput() {
      this.search.value = "";
      await this.getRecords();
    },

    async getDataTable() {
      const response = await this.$http.get(`/${this.resource}/data_table`)
      if (response.status && response.status === 200) {
        this.users = response.data.users
        this.origin_establishments = response.data.warehouses
        this.final_establishments = response.data.warehouses
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/DataTableTransfers.vue